import type { IOrderExperiment, IOrderItem } from '~/modules/order-analytic';
import type { RendererProps } from './type';

import { EReportColumnKey, EDimensionKey, IRMetricKey } from '~/presentation/reports/common/type';
import { OrderCellContainer } from './OrderCell';
import { CampaignsCell } from './CampaignsCell';
import { VersionCell } from './VersionCell';
import { OrderIdCell } from './OrderIdCell';
import { ItemsCell } from './ItemsCell';
import { DateCell } from './DateCell';

const isString = (value: unknown): value is string => typeof value === 'string';
const isNonEmptyArray = (value: unknown): value is unknown[] =>
  Array.isArray(value) && value.length > 0;

const isOrderItems = (value: unknown): value is IOrderItem[] => {
  return isNonEmptyArray(value);
};
const isOrderExperiments = (value: unknown): value is IOrderExperiment[] => {
  return isNonEmptyArray(value);
};

export const cellMap: Record<string, (props: RendererProps) => React.ReactNode> = {
  [EDimensionKey.VERSION]: ({ value, isMergedWithPrev }) => {
    if (!isString(value)) return null;
    return <VersionCell value={value} isMergedWithPrev={isMergedWithPrev} />;
  },
  [IRMetricKey.ORDERS]: ({ value, columnLayout, orderCellProps, previousValue, isTotalRow }) => {
    if (!isString(value)) return null;
    return (
      <OrderCellContainer
        value={value}
        columnLayout={columnLayout}
        orderCellProps={orderCellProps}
        previousValue={previousValue}
        isTotalRow={isTotalRow}
      />
    );
  },
  [EReportColumnKey.ORDER_DATE]: ({ value, isMergedWithPrev }) => {
    if (!isString(value)) return null;
    return <DateCell value={value} isMergedWithPrev={isMergedWithPrev} />;
  },
  [EReportColumnKey.ITEMS]: ({ value }) => {
    if (!isOrderItems(value)) return null;
    return <ItemsCell value={value} />;
  },
  [EReportColumnKey.CAMPAIGNS]: ({ value, campaignsCellProps }) => {
    if (!isOrderExperiments(value)) return null;
    return <CampaignsCell value={value} campaignsCellProps={campaignsCellProps} />;
  },
  [EReportColumnKey.ORDER_ID]: ({ value }) => {
    if (!isString(value)) return null;
    return <OrderIdCell value={value} />;
  },
};
